<template>
  <PrivacySection title="6. Conservazione dei Dati">
    <p>
      I dati personali sono conservati per il tempo necessario a conseguire le finalità 
      per le quali sono stati raccolti, nel rispetto dei termini di conservazione previsti 
      dalla legge:
    </p>
    <ul>
      <li><strong>Dati dell'applicazione mobile:</strong> conservati sul dispositivo 
          dell'utente fino alla disinstallazione dell'applicazione. L'utente può eliminare 
          i dati in qualsiasi momento attraverso le impostazioni dell'applicazione.</li>
      <li><strong>Dati del modulo di contatto:</strong> conservati per il tempo necessario 
          a evadere la richiesta e, comunque, non oltre 12 mesi dalla data dell'ultimo contatto, 
          salvo obblighi di legge che richiedano una conservazione più lunga.</li>
      <li><strong>Dati di navigazione:</strong> conservati per un periodo massimo di 12 mesi.</li>
      <li><strong>Cookie:</strong> i cookie tecnici vengono eliminati alla chiusura del browser, 
          salvo diversamente specificato.</li>
    </ul>
    <p>
      Trascorso il periodo di conservazione, i dati personali saranno cancellati o 
      anonimizzati in modo permanente.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'DataRetentionSection',
  components: {
    PrivacySection
  }
}
</script>

